/**
 * Button block functionality
 *
 * Wraps button content with span element for styling purposes.
 *
 * @since 1.0.0
 */
function buttonUtils() {
	const buttons = document.querySelectorAll('.wp-block-button');

	buttons.forEach(button => {
		const buttonLink = button.querySelector('.wp-block-button__link');
		if (buttonLink && !button.querySelector('.wp-block-button__content')) {
			const content = buttonLink.innerHTML;
			buttonLink.innerHTML = `<span class="wp-block-button__content">${content}</span>`;
		}
	});
}

document.addEventListener('DOMContentLoaded', buttonUtils);
